module.exports = __webpack_public_path__ + "img/1-Commrisk-Splash-Page-MVP.47519440.png";